import React from "react";
import style from "./SocialLinks.module.scss";
import IconFB from "../../../assets/social/facebook.svg";
import IconLI from "../../../assets/social/linkedin.svg";

const SocialLinks = () => (
  <div className={style.social_wrapper}>
    <a href='https://www.facebook.com/eleads.it' target='_blank'>
      <IconFB />
    </a>
    <a href='https://www.linkedin.com/company/e-leads' target='_blank'>
      <IconLI />
    </a>
  </div>
);

export default SocialLinks;
